import { CloseOutlined, LeftOutlined } from '@teko/ds-icon';
import {
  Body,
  BottomSheet,
  Col,
  Flex,
  LazyImage,
  Loading,
  styled,
} from '@teko/ds-mobile';
import { ProductGrid, REGION_NAME } from '@teko/teko-ecommerce';
import { LIMIT_ITEM_PER_PAGE_PRODUCT_LIST } from 'constants/index';
import { useSearch, useTenantConfig } from 'hooks';
import { t } from 'i18n';

interface RelatedProductsBottomSheetProps {
  sku: string;
  imageUrl?: string;
  name?: string;
  onBack?: () => void;
  closeBottomSheet?: () => void;
}

export const RelatedProductsBottomSheet: React.FC<
  RelatedProductsBottomSheetProps
> = (props: RelatedProductsBottomSheetProps) => {
  const { sku, imageUrl, name, closeBottomSheet, onBack } = props;
  const { contactLink } = useTenantConfig();
  const searchRelatedProductsParams = !!sku
    ? {
        page: 1,
        pageSize: LIMIT_ITEM_PER_PAGE_PRODUCT_LIST,
        filter: {
          skuToReturnSimilarProducts: sku,
        },
      }
    : {};

  const { result: searchRelatedProductsResult, isLoading } = useSearch(
    searchRelatedProductsParams,
  );
  return (
    <BottomSheet
      zIndex={1051}
      show={!!sku}
      contentHeight="80vh"
      showBottomSheetHeader={false}
    >
      <Col
        backgroundColor="background"
        borderTop="2px solid background"
        height="100%"
        width="100vw"
      >
        <Header align="center" justify="space-between">
          <LeftOutlined size={20} color="black" onClick={onBack} />
          <HeaderTitle level={1}>{t('Sản phẩm tương tự')}</HeaderTitle>
          <CloseOutlined size={24} color="black" onClick={closeBottomSheet} />
        </Header>
        <Loading isLoading={isLoading} />
        <Flex
          backgroundColor="white"
          align="center"
          justify="start"
          margin={['s8', 's8', 's4', 's8']}
          padding="s4"
          borderRadius="m"
          gap="s4"
        >
          {imageUrl && (
            <LazyImage width="60px" height="60px" src={imageUrl} contain />
          )}
          <div style={{ flex: 1 }}>
            <Body level={1} line={2}>
              {name}
            </Body>
          </div>
        </Flex>
        <Body level={1} paddingLeft="s8" marginBottom="s4">
          {t('Tìm thấy')}{' '}
          <strong>
            {searchRelatedProductsResult.pagination.totalItems <
            LIMIT_ITEM_PER_PAGE_PRODUCT_LIST
              ? searchRelatedProductsResult.pagination.totalItems
              : LIMIT_ITEM_PER_PAGE_PRODUCT_LIST}{' '}
          </strong>
          {t('sản phẩm tương tự')}
        </Body>
        <ProductGrid
          type="grid"
          products={searchRelatedProductsResult.products}
          regionName={REGION_NAME.SIMILAR_PRODUCTS_POPUP}
          contactLink={contactLink}
          productsPerRow={2}
          itemsPerPage={LIMIT_ITEM_PER_PAGE_PRODUCT_LIST}
        />
      </Col>
    </BottomSheet>
  );
};

const Header = styled(Flex)`
  min-height: 56px;
  padding: 16px 12px;
  border-bottom: 1px solid #e0e0e0;
  background: #fff;
`;

const HeaderTitle = styled(Body)`
  font-size: 16px;
  font-weight: 500;
  color: #000;
`;
